export default __webpack_public_path__ + "static/media/clarity_email-line.fc0bfcf5.svg";